import { render, staticRenderFns } from "./PerPageSelector.vue?vue&type=template&id=60688554&scoped=true"
import script from "./PerPageSelector.vue?vue&type=script&lang=js"
export * from "./PerPageSelector.vue?vue&type=script&lang=js"
import style0 from "./PerPageSelector.vue?vue&type=style&index=0&id=60688554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60688554",
  null
  
)

export default component.exports